const btnClass = {
  border: "btn--border",
  primary: "btn--primary",
  secondary: "btn--secondary",
};
export const Btn = ({ value, action, name }) => {
  return (
    <button onClick={action} className={`btn ` + btnClass[name]}>
      {value}
    </button>
  );
};
